/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressTriggerWorkflowListResponse } from '../../models/address-trigger-workflow-list-response';

export interface GetAllAddressTriggerWorkflows$Params {
}

export function getAllAddressTriggerWorkflows(http: HttpClient, rootUrl: string, params?: GetAllAddressTriggerWorkflows$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressTriggerWorkflowListResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllAddressTriggerWorkflows.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddressTriggerWorkflowListResponse>;
    })
  );
}

getAllAddressTriggerWorkflows.PATH = '/api/v1/workflows/address-trigger-workflows';
